import './Projects.css';

function Projects() {
    return (
        <h1>Penelope's Projects</h1>
    )
}

export default Projects;
